import { ReactNode, useState } from 'react';
import { Tool } from '@/types/tool';
import { FilterContext } from './FilterContext';

interface FilterProviderProps {
  children: ReactNode;
}

export const FilterProvider = ({ children }: FilterProviderProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const filterTools = (tools: Tool[]) => {
    return tools.filter((tool) => {
      const matchesSearch =
        !searchQuery ||
        tool.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        tool.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tool.tags && tool.tags.some((tag) => tag.toLowerCase().includes(searchQuery.toLowerCase())));

      const matchesCategory = !selectedCategory || 
        (tool.categories && tool.categories.some(category => 
          category.toLowerCase() === selectedCategory.toLowerCase()
        ));

      return matchesSearch && matchesCategory;
    });
  };

  return (
    <FilterContext.Provider
      value={{
        searchQuery,
        selectedCategory,
        setSearchQuery,
        setSelectedCategory,
        filterTools,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};